import Image_1 from './1.png'
import Image_2 from './2.png'
import Image_3 from './3.png'
import Image_4 from './4.png'

const listImg = [Image_1, Image_2, Image_3, Image_4]

export default listImg
